import inputTypes from "../../../../formComponents/formFields/constants";

const formFields = {
  email: {
    default: undefined,
    type: inputTypes.SIMPLE_TEXT,
    required: true,
    label: "Email address",
  },
  action_type: {
    default: undefined,
    type: inputTypes.SELECT,
    required: true,
    label: "Action",
    options: [
      {
        label: "Account Info",
        value: "account_info",
      },
      {
        label: "Activation status",
        value: "activation_status",
      },
      {
        label: "Reactivate",
        value: "reactivate",
      },
      {
        label: "Deactivate",
        value: "deactivate",
      },
      {
        label: "Verify user",
        value: "verify",
      },
      {
        label: "Password reset URL",
        value: "password_url",
      },
      {
        label: "Verification URL",
        value: "verify_url",
      },
      {
        label: "Unsubscribe",
        value: "unsubscribe",
      },
      {
        label: "Delete profile info",
        value: "delete_all_info",
      },
      {
        label: "Force user as a challenger",
        value: "force_challenger",
      },
    ],
  },
  company_team_id: {
    default: undefined,
    type: inputTypes.SELECT,
    required: true,
    settings: {
      optionsFetchFrom: {
        url: "/admin/contests/form_selects/company_teams",
        cacheKey: "adminFormSelectsCompanyTeams",
      },
    },
  },
};

const inputsConfigWithNames = Object.fromEntries(
  Object.entries(formFields).map(([fKey, fVal]) => [
    fKey,
    { name: fKey, ...fVal },
  ]),
);

export default inputsConfigWithNames;
